import React from "react";
import { Link } from "react-router-dom";

import Breadcrumb from "../../../../components/Breadcrum";
import automobiles from "../../../../data/automobileData";

import "./Automobiles.css";

export default function Automobiles() {
  return (
    <>
      <Breadcrumb
        title="Automobile Solutions"
        backgroundImage="/assets/img/contact-banner.png"
        height="45vh"
      />

      <section className="automobile-section">
        <div className="container">
          <div className="section-heading">
            <h1>Automobile Solutions</h1>

            <p>
              Explore our premium range of automobiles designed with modern
              technology, superior performance, exceptional safety, and luxury
              comfort.
            </p>
          </div>

          <div className="car-grid">
            {automobiles.map((car) => (
              <article className="car-card" key={car.id}>
                <div className="car-image">
                  <img
                    src={car.image}
                    alt={car.name}
                    loading="lazy"
                  />
                </div>

                <div className="car-content">
                  <h2>{car.name}</h2>

                  <p>{car.shortDescription}</p>

                  <Link
                    to={`/business/automobiles/${car.slug}`}
                    className="view-btn"
                  >
                    View Details
                    <span>→</span>
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}